import React from "react";
import Queue from "nq-js";
import { dialog } from "nq-component";
import CameraCapture from "../CameraCapture";
import click from "../../click";

const defaultProps = {
  height: "250px",
};

function InputCamera({ onChange, saveImage, noCamera, disabled }) {
  const [progress, setProgress] = React.useState(0);
  const [image, setImage] = React.useState(null);
  const [isPopop, setPopop] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const printRef = React.useRef();

  function readImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  function validateFile(file) {
    const maxFileSize = 5 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png"];

    if (!file) {
      setErrorMessage("No file selected.");
      setTimeout(() => setErrorMessage(""), 3000);
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      setErrorMessage("Only JPEG or PNG images are allowed.");
      setTimeout(() => setErrorMessage(""), 3000);
      return false;
    }

    if (file.size > maxFileSize) {
      setErrorMessage("Image size must not exceed 5 MB.");
      setTimeout(() => setErrorMessage(""), 3000);
      return false;
    }

    setErrorMessage("");
    return true;
  }

  function onClick() {
    const capture = async (canvas) => {
      dialog.close();
      setImage(canvas.toDataURL());
      const file = await Queue.canvasToBlob(canvas, "capture.png", "image/png");
      const result = await saveImage.execute(file);
      onChange(result.url);
    };
    dialog.fire({
      component: (
        <div>
          <button
            onClick={() => dialog.close()}
            className="btn btn-sm btn-link  float-end"
          >
            <i className="bi bi-x fs-2"></i>
          </button>
          <CameraCapture onCapture={capture} />
        </div>
      ),
      footer: false,
    });
  }

  function onClickIcon(e) {
    e.preventDefault();
    onClick();
  }

  function onFileSelected(file) {
    if (!validateFile(file)) return;

    readImage(file);
    const options = {
      progress: (value) => setProgress(value * 100),
    };
    saveImage
      .execute(file, options)
      .then((result) => {
        setImage(result.url);
        setProgress(0);
        onChange(result.url);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function onClickBrowse() {
    if (disabled) return;
    const input = document.createElement("input");
    input.type = "file";
    // input.accept = "img";
    input.onchange = (e) => {
      const [file] = e.target.files;
      file && onFileSelected(file);
    };
    click(input);
  }

  return (
    <div className="d-flex  align-items-center">
      <div
        className="d-flex align-items-center justify-content-start"
        onClick={onClickBrowse}
        style={{
          width: "200px",
          height: "55px",
          border: "2px dashed red",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
          borderRadius: "6px",
          backgroundColor: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <i
          className="bi bi-upload m-3"
          style={{ color: "red", fontSize: "18px" }}
        ></i>
        <span>Upload</span>
      </div>
      {noCamera ? (
        ""
      ) : (
        <button
          className="d-flex align-items-center ms-1"
          onClick={(e) => onClickIcon(e)}
          style={{
            border: "none",
            cursor: "pointer",
            outline: "none",
            backgroundColor: "transparent",
          }}
        >
          <div
            className="text-white d-flex justify-content-center align-items-center"
            onMouseOver={() => {
              setPopop(true);
            }}
            onMouseLeave={() => {
              setPopop(false);
            }}
            style={{
              backgroundColor: "#3F7CC0",
              borderRadius: "5px",
              padding: "6px 14px",
              fontSize: "29px",
            }}
          >
            <i className="bi bi-camera-fill"></i>
          </div>
          <div
            className="position-relative"
            style={{ display: "inline-block" }}
          >
            {isPopop && (
              <div
                className="position-absolute"
                onMouseOver={() => {
                  setPopop(true);
                }}
                onMouseLeave={() => {
                  setPopop(false);
                }}
                style={{
                  top: "-50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#000",
                  color: "#fff",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  zIndex: 10,
                }}
              >
                Click to capture a picture of yourself
                <div
                  style={{
                    position: "absolute",
                    bottom: "-6px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "0",
                    height: "0",
                    borderLeft: "6px solid transparent",
                    borderRight: "6px solid transparent",
                    borderTop: "6px solid #000",
                  }}
                ></div>
              </div>
            )}
          </div>
        </button>
      )}

      {errorMessage && (
        <div
          style={{
            marginTop: "10px",
            padding: "8px 12px",
            backgroundColor: "#f8d7da",
            color: "#721c24",
            border: "1px solid #f5c6cb",
            borderRadius: "5px",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
}

InputCamera.defaultProps = defaultProps;
export default InputCamera;
